import { render, staticRenderFns } from "./MypagePointsPage.vue?vue&type=template&id=00ff82c3&"
import script from "./MypagePointsPage.vue?vue&type=script&lang=js&"
export * from "./MypagePointsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports